import http from 'services/http-service';

const BannerService = {
    Create(name: string, redirectUrl: string, checkoutUrl: string, isRedirectToNewWindow: any, posterImage: any) {
        let formData = new FormData();
        formData.append("name", name);
        formData.append("redirectUrl", redirectUrl);
        formData.append("checkoutUrl", checkoutUrl);
        formData.append("isRedirectToNewWindow", isRedirectToNewWindow);
        formData.append("posterImage", posterImage);

        var result = http.post("/banners", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    Update(bannerId: any, name: string, redirectUrl: string, checkoutUrl: string, isRedirectToNewWindow: any, status: number, sequence:any) {
        var response = http.put(`/banners/${bannerId}`, { name, redirectUrl, checkoutUrl, isRedirectToNewWindow, status, sequence });
        return response;
    },

    ChangeBannerImage(bannerId: any, posterImage: any) {
        let formData = new FormData();
        formData.append("posterImage", posterImage);

        var result = http.put(`/banners/${bannerId}/image`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    Delete(bannerId: any) {
        var response = http.delete(`/banners/${bannerId}`);
        return response;
    },

    GetAll() {
        var response = http.get("/banners/all");
        return response;
    },

    Get(bannerId: any) {
        var response = http.get(`/banners/${bannerId}`);
        return response;
    }
};

export default BannerService;